import './Button.scss'
import Component from 'navigation/component/Component'

type ButtonType = {}
class Button extends Component<ButtonType> {}

export default Button
